module.exports = __webpack_public_path__ + "static/automate-2b5d69c17ed215cdcd7d3f10ab4a1ec0.png";